import * as React from 'react';
import { range } from 'lodash';
import { styled } from '@mui/material/styles';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Typography from '@mui/material/Typography';
import Flex from 'ui/Flex/Flex';
import { useGetUnreadNotifications } from 'routes/Home/hooks/useGetUnreadNotifications';
import { useTranslation } from 'react-i18next';
import { NotificationsOffOutlined } from '@mui/icons-material';
import UnreadNotification from './UnreadNotification';
import UnreadNotificationLoading from './UnreadNotification.loading';

const StyNotificationContainer = styled(Flex, {
    name: 'StyNotificationContainer',
})(({ theme }) => ({
    height: '50px',
    flexGrow: 1,
    backgroundColor: theme.palette.primary.background,
    padding: '16px',
    borderRadius: '8px',
    minHeight: '50px',
    minWidth: '350px',
    width: '350px',
    [theme.breakpoints.down('lg')]: {
        display: 'none',
    },
}));

const UnreadNotifications = (): JSX.Element => {
    const { data: unreadNotifications, isLoading } =
        useGetUnreadNotifications();
    const { t } = useTranslation();

    return (
        <StyNotificationContainer direction="column">
            <Flex align="center" sx={{ gap: 1 }}>
                <NotificationsIcon color="primary" />
                <Typography variant="h5">
                    {t('home.notifications.title')}
                </Typography>
            </Flex>
            <Flex
                direction="column"
                sx={{ gap: 2, mt: 2, flexGrow: 1, overflowY: 'scroll' }}
            >
                {/* Display the notifications */}
                {unreadNotifications?.map((unreadNotification) => (
                    <UnreadNotification
                        notification={unreadNotification}
                        key={unreadNotification.id}
                    />
                ))}

                {/* Notifications are loading */}
                {isLoading &&
                    range(3).map((number) => (
                        <UnreadNotificationLoading key={number} />
                    ))}

                {/* Notifications are empty */}
                {!isLoading && unreadNotifications?.length === 0 && (
                    <Flex
                        direction="column"
                        align="center"
                        justify="center"
                        sx={{ gap: 2, px: 4, height: '100%' }}
                    >
                        <NotificationsOffOutlined
                            sx={{
                                height: '32px',
                                width: '32px',
                                color: '#899FB1',
                            }}
                        />
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 600,
                                textAlign: 'center',
                                color: '#899FB1',
                            }}
                        >
                            {t('home.notifications.empty')}
                        </Typography>
                    </Flex>
                )}
            </Flex>
        </StyNotificationContainer>
    );
};

export default UnreadNotifications;
